import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = guest
  const [schoolId, setSchoolIdState] = useState(localStorage.getItem("sb_school_id") || "");
  const [academicYear, setAcademicYearState] = useState(localStorage.getItem("sb_ayear") || "");

  useEffect(() => {
    if (!localStorage.getItem("sb_token")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sb_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("sb_token");
    localStorage.removeItem("sb_school_id");
    setUser(false);
  }, []);

  const applyAuth = useCallback((token, userData) => {
    localStorage.setItem("sb_token", token);
    setUser(userData);
  }, []);

  const setSchoolId = useCallback((id) => {
    if (id) localStorage.setItem("sb_school_id", id);
    else localStorage.removeItem("sb_school_id");
    setSchoolIdState(id);
  }, []);

  const setAcademicYear = useCallback((y) => {
    if (y) localStorage.setItem("sb_ayear", y);
    else localStorage.removeItem("sb_ayear");
    setAcademicYearState(y);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, applyAuth, schoolId, setSchoolId, academicYear, setAcademicYear }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
